module.exports = __webpack_public_path__ + "media/images/plans/dinner/point-2-08fecd0f366be187f98453f4651cce81.jpg";